// Simple orbit ellipse - sketchy
export function OrbitLine({
  width = 80,
  height = 40,
  color = 'rgba(255, 226, 188, 0.3)',
  className = ''
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
    >
      {/* Imperfect elliptical orbit */}
      <ellipse
        cx={width / 2}
        cy={height / 2}
        rx={width / 2 - 2}
        ry={height / 2 - 2}
        stroke={color}
        strokeWidth="1"
        strokeDasharray="3 2"
        fill="none"
      />
    </svg>
  );
}
